import { Country, CountryScope } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountries: (
  fetchContext: FetchContext,
  scope: CountryScope,
  searchText?: string,
  accessToken?: string,
) => Promise<Country[]> = (fetchContext, scope, searchText, accessToken) => {
  const params = new URLSearchParams();
  params.append('scope', scope);
  if (searchText && searchText.length > 0) params.append('searchText', searchText);

  return fetch(`${fetchContext.baseUrl}/api/countries${params.size > 0 ? `?${params}` : ''}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => responseErrorHandler<Country[]>(fetchContext.errorStore, response, 'get countries'));
};
